const BASE_URL = '/activities/deals/batch';

const massReschedule = (activities, newDate) => {
    const payload = {
        action: 'reschedule',
        reschedule_date: newDate,
        ...populateActivitiesIds(
            activities.filter(({ type }) => ['task', 'phonecall'].includes(type)),
        ),
    };
    delete payload.events;
    return ApiClient.post(BASE_URL, {}, payload);
};

const massMarkAsDone = (activities) => {
    const payload = {
        action: 'done',
        ...populateActivitiesIds(
            activities.filter(({ type }) => ['task', 'phonecall'].includes(type)),
        ),
    };
    delete payload.events;
    return ApiClient.post(BASE_URL, {}, payload);
};

const massModifyOwner = (activities, owner) => {
    const payload = {
        action: 'assign_owner',
        owner_id: owner,
        ...populateActivitiesIds(
            activities.filter(({ type }) => ['task', 'phonecall'].includes(type)),
        ),
    };
    delete payload.events;
    return ApiClient.post(BASE_URL, {}, payload);
};

const massAssignAddStaff = (activities, staff) => {
    const payload = {
        action: 'add_assignees',
        assigned_staff_ids: staff,
        ...populateActivitiesIds(activities.filter(({ type }) => ['task'].includes(type))),
    };
    delete payload.events;
    delete payload.phonecalls;
    return ApiClient.post(BASE_URL, {}, payload);
};

const massAssignReplaceStaff = (activities, staff) => {
    const payload = {
        action: 'replace_assignees',
        assigned_staff_ids: staff,
        ...populateActivitiesIds(activities.filter(({ type }) => ['task'].includes(type))),
    };
    delete payload.events;
    delete payload.phonecalls;
    return ApiClient.post(BASE_URL, {}, payload);
};

const massDelete = (activities) => {
    const payload = {
        action: 'delete',
        ...populateActivitiesIds(activities),
    };
    delete payload.events;
    return ApiClient.post(BASE_URL, {}, payload);
};

const populateActivitiesIds = (activities) => {
    const events = activities
        .filter(({ type }) => type === 'event')
        .map(({ activityId }) => activityId);
    const tasks = activities
        .filter(({ type }) => type === 'task')
        .map(({ activityId }) => activityId);
    const phonecalls = activities
        .filter(({ type }) => type === 'phonecall')
        .map(({ activityId }) => activityId);
    return {
        events,
        tasks,
        phonecalls,
    };
};

export {
    massReschedule,
    massMarkAsDone,
    massModifyOwner,
    massAssignAddStaff,
    massAssignReplaceStaff,
    massDelete,
};
